import React from "react";
import { Route, Redirect } from "react-router-dom";

import Cookies from "js-cookie";

const Logout = () => {

    // Removed by Jericho 2023-08-18 - Clear all localStorage items instead of removing one by one
    // localStorage.removeItem("loggedUser");
    // localStorage.removeItem("access_token");
    // localStorage.removeItem("aggregates");
    // localStorage.removeItem("aggregates_updated");
    // localStorage.removeItem("logo");
    // localStorage.removeItem("dashboardtheme");
    // localStorage.removeItem("cbm_merchant");
    // localStorage.removeItem("authuser");
    // localStorage.removeItem("expiry");
    // localStorage.removeItem("isIdle");
    
    Cookies.remove("access");
    Cookies.remove("groups");
    Cookies.remove("authuser");
    Cookies.remove("menu_items");
    Cookies.remove("access_token");
    Cookies.remove("associations");

    Cookies.remove("userid");
    Cookies.remove("remember_me");
    Cookies.remove("cookie_enabled");
    Cookies.remove("verify_option");

    Cookies.remove("oiAssociation");
    Cookies.remove("cbm_token");
    Cookies.remove("threeds_token");
    Cookies.remove("txalert_token");
    Cookies.remove("txfind_token");
    Cookies.remove("dm_token");
    Cookies.remove("dm_userids");
    // remove all item from localstorage
    localStorage.clear();
    return (
        <Route>
            <Redirect to="/login"/>
        </Route>
    );
};
export default Logout;
